import React from 'react';
import { Box, ThemeProvider, CssBaseline } from '@mui/material';
import theme from '../../styles/theme';
import AuthForm from '../../components/Auth/AuthForm';
import Header from '../../components/Header/Header';

const SignUp: React.FC = () => {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Box>
        <Header />
        <AuthForm isLogin={false} />
      </Box>
    </ThemeProvider>
  );
};

export default SignUp; 